import reservationsService from "api/reservationsService"
import { AxiosResponse } from "axios"
import { useQuery } from "react-query"

const useGetCarWashWashers = (carWashId: number, enabled: boolean) => {
  return useQuery(
    ["reservation-get-car-wash-washers", carWashId],
    async () => {
      try {
        const res: AxiosResponse<any> =
          await reservationsService.getCarWashWashers(carWashId)
        return res.data
      } catch (err: any) {
        err.response
      }
    },
    { enabled },
  )
}

export default useGetCarWashWashers
